import { useState } from "react"
import { getDiskonByInsurance } from "../../../DaftarPenjualan/helpers"

const ID_TYPE_OF_CARE = {
  IGD: 1,
  RAJAL: 2,
  RANAP: 3,
}

export default function useMutationDiskon() {
  const [isLoading, setIsLoading] = useState(false)

  const getDiskon = async (idTypeOfCare, insuranceID) => {
    try {
      setIsLoading(true)
      const diskon = await getDiskonByInsurance(insuranceID)

      const jenisRawat = idTypeOfCare
      const dataDiskon = diskon.data
      if (diskon.state) {
        if (jenisRawat === ID_TYPE_OF_CARE.RAJAL) {
          return {
            diskon_barang: dataDiskon.diskon_barang_rajal,
            diskon_jasa: dataDiskon.diskon_jasa_rajal,
            diskon_fasilitas: dataDiskon.diskon_fasilitas_rajal,
            diskon_rikjang: dataDiskon.diskon_rikjang_rajal,
          }
        } else if (jenisRawat === ID_TYPE_OF_CARE.RANAP) {
          return {
            diskon_barang: dataDiskon.diskon_barang_ranap,
            diskon_jasa: dataDiskon.diskon_jasa_ranap,
            diskon_fasilitas: dataDiskon.diskon_fasilitas_ranap,
            diskon_rikjang: dataDiskon.diskon_rikjang_ranap,
          }
        } else if (jenisRawat === ID_TYPE_OF_CARE.IGD) {
          return {
            diskon_barang: dataDiskon.diskon_barang_igd,
            diskon_jasa: dataDiskon.diskon_jasa_igd,
            diskon_fasilitas: dataDiskon.diskon_fasilitas_igd,
            diskon_rikjang: dataDiskon.diskon_rikjang_igd,
          }
        } else {
          return {
            diskon_barang: 0,
            diskon_jasa: 0,
            diskon_fasilitas: 0,
            diskon_rikjang: 0,
          }
        }
      }
    } catch (error) {
      console.log("ERROR FETCH DISKON", error)
      return {
        diskon_barang: 0,
        diskon_jasa: 0,
        diskon_fasilitas: 0,
        diskon_rikjang: 0,
      }
    } finally {
      setIsLoading(false)
    }
  }
  return {
    getDiskon,
    isLoading,
  }
}
